<template>
  <div class="comp-shortcut-btn">
    <template v-if="btnPermissionArr?.length">
      <template v-for="(b, i) in btnPermissionArr.slice(0, moreNumber)" :key="i">
        <jw-tooltip :content="buttonTexts?.[b]" position="bottom" :content-style="{ borderRadius: '4px' }">
          <!-- 添加动态记录 -->
          <div class="shortcut-btn" @click="addDynamicRecord()" v-if="b == `${oem[entity]}:addDynamicRecord`">
            <qfei-icon-record-add-outlined />
            <div class="shortcut-btn-text">{{ buttonTexts?.[`${oem[entity]}:addDynamicRecord`] }}</div>
          </div>
          <!-- 编辑：edit 锁定状态不能看到编辑 线索池除外   -->
          <template v-if="b === `${oem[entity]}:edit`">
            <div class="shortcut-btn" @click="toEdit(record)">
              <qfei-icon-edit-outlined />
              <div class="shortcut-btn-text">{{ buttonTexts?.[`${oem[entity]}:edit`] }}</div>
            </div>
          </template>
          <!-- 转移：transfer -->
          <template v-if="entity == 3">
            <template v-if="!record?.lockedOrigin && record?.statusOrigin != 1 && record?.statusOrigin != 6">
              <div class="shortcut-btn" @click="leadBatch(record)" v-if="record?.customerId && record?.opportunityStatus != '赢单' && b == `${oem[entity]}:transfer` && userInfo?.roles?.indexOf(`${oem[entity]}:transfer`) !== -1">
                <qfei-icon-move-outlined />
                <div class="shortcut-btn-text">{{ buttonTexts?.[`${oem[entity]}:transfer`] }}</div>
              </div>
            </template>
          </template>
          <template v-else-if="entity == 101">
            <div class="shortcut-btn" @click="leadPoolBatch(record)" v-if="entity == 101 && b == `${oem[entity]}:transfer` && userInfo?.roles?.indexOf(`${oem[entity]}:transfer`) !== -1">
              <qfei-icon-move-outlined />
              <div class="shortcut-btn-text">{{ buttonTexts?.[`${oem[entity]}:transfer`] }}</div>
            </div>
          </template>
          <template v-else>
            <template v-if="!record?.lockedOrigin && record?.statusOrigin != 1 && record?.statusOrigin != 6">
              <div class="shortcut-btn" @click="leadBatch(record)" v-if="b == `${oem[entity]}:transfer` && userInfo?.roles?.indexOf(`${oem[entity]}:transfer`) !== -1">
                <qfei-icon-move-outlined />
                <div class="shortcut-btn-text">{{ buttonTexts?.[`${oem[entity]}:transfer`] }}</div>
              </div>
            </template>
          </template>
          <!-- 转移：transfer -->
          <!-- 退回：return 转化：transform -->
          <div class="shortcut-btn" @click="returnClue(record)" v-if="b == `${oem[entity]}:return`">
            <qfei-icon-return-order-outlined />
            <div class="shortcut-btn-text">{{ buttonTexts?.[`${oem[entity]}:return`] }}</div>
          </div>
          <div class="shortcut-btn" @click="conversion(record)" v-if="b == `${oem[entity]}:transform`">
            <qfei-icon-conversion-two-outlined />
            <div class="shortcut-btn-text">{{ buttonTexts?.[`${oem[entity]}:transform`] }}</div>
          </div>
          <!-- 退回：return 转化：transform -->
          <!-- 分享：share -->
          <span v-if="b == `${oem[entity]}:share`">
            <xl-tree-member-modal :key="`${oem[entity]}:share`" @cb="getVal" :tree="{ checkDepartment: false, isAll: true }">
              <div class="shortcut-btn" @click="toShare(record)">
                <qfei-icon-share-outlined />
                <div class="shortcut-btn-text">{{ buttonTexts?.[`${oem[entity]}:share`] }}</div>
              </div>
            </xl-tree-member-modal>
          </span>
          <!-- 删除：delete -->
          <div class="shortcut-btn" @click="deleteRow(record)" v-if="b == `${oem[entity]}:delete`">
            <qfei-icon-delete-outlined />
            <div class="shortcut-btn-text">{{ buttonTexts?.[`${oem[entity]}:delete`] }}</div>
          </div>
          <!-- 数据校准：dataCheck -->
          <div class="shortcut-btn" @click="saveDataCheck(record)" v-if="b == `${oem[entity]}:dataCheck`">
            <qfei-icon-business-opportunity-outlined />
            <div class="shortcut-btn-text">{{ buttonTexts?.[`${oem[entity]}:dataCheck`] }}</div>
          </div>
          <!-- 复制：copy -->
          <div class="shortcut-btn" @click="copyClue(record)" v-if="b == `${oem[entity]}:copy`">
            <qfei-icon-copy-outlined />
            <div class="shortcut-btn-text">{{ buttonTexts?.[`${oem[entity]}:copy`] }}</div>
          </div>
          <!-- 拨打电话：calling -->
          <div class="shortcut-btn" @click="dialPhone(record)" v-if="b == `${oem[entity]}:calling`" :class="{ 'btn-disabled-loading': record.id === data.record.id && data.outCallDisabled }">
            <qfei-icon-phone-outlined />
            <div class="shortcut-btn-text">{{ buttonTexts?.[`${oem[entity]}:calling`] }}</div>
          </div>
          <!-- 领取 -->
          <div class="shortcut-btn" :class="{ 'btn-disabled-loading': currentCollectionClue == record.id && poolLoading }" v-if="b == `${oem[entity]}:receive`" @click="collectionClue(record)">
            <qfei-icon-order-outlined />
            <div class="shortcut-btn-text">{{ buttonTexts?.[`${oem[entity]}:receive`] }}</div>
          </div>
          <!-- 分配 -->
          <div class="shortcut-btn" v-if="b == `${oem[entity]}:allocation`" @click="distribution(record)">
            <qfei-icon-sub-task-outlined />
            <div class="shortcut-btn-text">{{ buttonTexts?.[`${oem[entity]}:allocation`] }}</div>
          </div>
          <!-- 客户的Bing数据同步 -->
          <div class="shortcut-btn" @click="bingSyncData(record)" :class="{ 'btn-disabled-loading': record.id === data.id && data.outCallDisabled }" v-if="b == `${oem[entity]}:bingDataSync`">
            <qfei-icon-refresh-outlined />
            <div class="shortcut-btn-text">{{ buttonTexts?.[`${oem[entity]}:bingDataSync`] }}</div>
          </div>
          <!-- 客户中Bing租户的特殊操作：bingUserInviteSync -->
          <div class="shortcut-btn" @click="bingUserInviteSync(record)" v-if="b == `${oem[entity]}:bingUserInviteSync`">
            <div class="shortcut-btn-text">{{ buttonTexts?.[`${oem[entity]}:bingUserInviteSync`] }}</div>
          </div>
          <!-- 销售订单中的Bing链接 -->
          <div class="shortcut-btn" @click="bingUrl(record)" v-if="b == `${oem[entity]}:bingUrl`">
            <div class="shortcut-btn-text">{{ buttonTexts?.[`${oem[entity]}:bingUrl`] }}</div>
          </div>
          <!-- UI后台详情 -->
          <div class="shortcut-btn" :key="i" @click="bingUserInviteUrlSync(record)" v-if="b == `${oem[entity]}:bingUserInviteUrlSync`">
            <div class="shortcut-btn-text">{{ buttonTexts?.[`${oem[entity]}:bingUserInviteUrlSync`] }}</div>
          </div>
        </jw-tooltip>
      </template>
      <template v-if="btnPermissionArr.length > moreNumber">
        <xl-tree-member-modal ref="memberRef" @cb="getVal" :tree="{ checkDepartment: false, isAll: true }">
          <span></span>
        </xl-tree-member-modal>
        <jw-dropdown class="shortcut-btn" @select="selectButton" ref="dropdown" :position="morePosition" :show-arrow="morePosition == 'top' ? true : false" :arrow-style="{ border: '1px solid var(--color-fill-3)', zIndex: '9999', borderTop: 'none', borderLeft: 'none' }" @popup-visible-change="handlePopupVisibleChange">
          <div class="more-btn">
            <slot name="board-view">
              <icon-more />
            </slot>
          </div>
          <template #content>
            <jw-doption v-for="(b, i) in btnPermissionArr.slice(moreNumber)" :key="i" :title="buttonTexts?.[b]">
              <!-- 添加动态记录 -->
              <div class="shortcut-btn-more" v-if="b == `${oem[entity]}:addDynamicRecord`">
                <qfei-icon-record-add-outlined />
                <div class="shortcut-btn-more-text">{{ buttonTexts?.[`${oem[entity]}:addDynamicRecord`] }}</div>
              </div>
              <!-- 编辑：edit 锁定状态不能看到编辑 线索池除外   -->
              <div class="shortcut-btn-more" v-if="b === `${oem[entity]}:edit`">
                <qfei-icon-edit-outlined />
                <div class="shortcut-btn-more-text">{{ buttonTexts?.[`${oem[entity]}:edit`] }}</div>
              </div>
              <!-- 转移：transfer -->
              <template v-if="entity == 3">
                <template v-if="!record?.lockedOrigin && record?.statusOrigin != 1 && record?.statusOrigin != 6">
                  <div class="shortcut-btn-more" v-if="record?.customerId && record?.opportunityStatus != '赢单' && b == `${oem[entity]}:transfer` && userInfo?.roles?.indexOf(`${oem[entity]}:transfer`) !== -1">
                    <qfei-icon-move-outlined />
                    <div class="shortcut-btn-more-text">{{ buttonTexts?.[`${oem[entity]}:transfer`] }}</div>
                  </div>
                </template>
              </template>
              <template v-else-if="entity == 101">
                <div class="shortcut-btn-more" v-if="entity == 101 && b == `${oem[entity]}:transfer` && userInfo?.roles?.indexOf(`${oem[entity]}:transfer`) !== -1">
                  <qfei-icon-move-outlined />
                  <div class="shortcut-btn-more-text">{{ buttonTexts?.[`${oem[entity]}:transfer`] }}</div>
                </div>
              </template>
              <template v-else>
                <template v-if="!record?.lockedOrigin && record?.statusOrigin != 1 && record?.statusOrigin != 6">
                  <div class="shortcut-btn-more" v-if="b == `${oem[entity]}:transfer` && userInfo?.roles?.indexOf(`${oem[entity]}:transfer`) !== -1">
                    <qfei-icon-move-outlined />
                    <div class="shortcut-btn-more-text">{{ buttonTexts?.[`${oem[entity]}:transfer`] }}</div>
                  </div>
                </template>
              </template>
              <!-- 转移：transfer -->

              <!-- 退回：return 转化：transform -->
              <div class="shortcut-btn-more" v-if="b == `${oem[entity]}:return`">
                <qfei-icon-return-order-outlined />
                <div class="shortcut-btn-more-text">{{ buttonTexts?.[`${oem[entity]}:return`] }}</div>
              </div>
              <div class="shortcut-btn-more" v-if="b == `${oem[entity]}:transform`">
                <qfei-icon-conversion-two-outlined />
                <div class="shortcut-btn-more-text">{{ buttonTexts?.[`${oem[entity]}:transform`] }}</div>
              </div>
              <!-- 退回：return 转化：transform -->

              <!-- 分享：share -->
              <div class="shortcut-btn-more" v-if="b == `${oem[entity]}:share`">
                <qfei-icon-share-outlined />
                <div class="shortcut-btn-more-text">{{ buttonTexts?.[`${oem[entity]}:share`] }}</div>
              </div>

              <!-- 删除：delete -->
              <div class="shortcut-btn-more" v-if="b == `${oem[entity]}:delete`">
                <qfei-icon-delete-outlined />
                <div class="shortcut-btn-more-text">{{ buttonTexts?.[`${oem[entity]}:delete`] }}</div>
              </div>

              <!-- 数据校准：dataCheck -->
              <div class="shortcut-btn-more" v-if="b == `${oem[entity]}:dataCheck`">
                <qfei-icon-business-opportunity-outlined />
                <div class="shortcut-btn-more-text">{{ buttonTexts?.[`${oem[entity]}:dataCheck`] }}</div>
              </div>

              <!-- 复制：copy -->
              <div class="shortcut-btn-more" v-if="b == `${oem[entity]}:copy`">
                <qfei-icon-copy-outlined />
                <div class="shortcut-btn-more-text">{{ buttonTexts?.[`${oem[entity]}:copy`] }}</div>
              </div>
              <!-- 拨打电话：calling -->
              <div class="shortcut-btn-more" v-if="b == `${oem[entity]}:calling`" :class="{ 'btn-disabled-loading': record.id === data.record.id && data.outCallDisabled }">
                <qfei-icon-phone-outlined />
                <div class="shortcut-btn-more-text">{{ buttonTexts?.[`${oem[entity]}:calling`] }}</div>
              </div>
              <!-- 领取 -->
              <div class="shortcut-btn-more" :class="{ 'btn-disabled-loading': currentCollectionClue == record.id && poolLoading }" v-if="b == `${oem[entity]}:receive`">
                <qfei-icon-order-outlined />
                <div class="shortcut-btn-more-text">{{ buttonTexts?.[`${oem[entity]}:receive`] }}</div>
              </div>
              <!-- 分配 -->
              <div class="shortcut-btn-more" v-if="b == `${oem[entity]}:allocation`">
                <qfei-icon-sub-task-outlined />
                <div class="shortcut-btn-more-text">{{ buttonTexts?.[`${oem[entity]}:allocation`] }}</div>
              </div>
              <!-- 客户的Bing数据同步 -->
              <div class="shortcut-btn-more" :class="{ 'btn-disabled-loading': record.id === data.id && data.outCallDisabled }" v-if="b == `${oem[entity]}:bingDataSync`">
                <qfei-icon-refresh-outlined />
                <div class="shortcut-btn-more-text">{{ buttonTexts?.[`${oem[entity]}:bingDataSync`] }}</div>
              </div>
              <!-- 客户中Bing租户的特殊操作：bingUserInviteSync -->
              <div v-if="b == `${oem[entity]}:bingUserInviteSync`">{{ buttonTexts?.[`${oem[entity]}:bingUserInviteSync`] }}</div>
              <!-- 销售订单中的Bing链接 -->
              <div v-if="b == `${oem[entity]}:bingUrl`">{{ buttonTexts?.[`${oem[entity]}:bingUrl`] }}</div>
              <!-- UI后台详情 -->
              <div :key="i" v-if="b == `${oem[entity]}:bingUserInviteUrlSync`">{{ buttonTexts?.[`${oem[entity]}:bingUserInviteUrlSync`] }}</div>
            </jw-doption>
          </template>
        </jw-dropdown>
      </template>
    </template>
    <template v-else>-</template>
    <teleport to="body">
      <div style="height: 0">
        <template v-if="isShowComponents">
          <!-- 转化线索  -->
          <clue-conversion ref="conversionRef"></clue-conversion>
          <!-- 退回 -->
          <xl-return ref="returnRef" @cb="refreshList('return')"></xl-return>
          <!-- 转移 S-->
          <xl-transfer ref="transferRef" @cb="refreshList('transfer')" :type="entity"></xl-transfer>
          <!-- 拨打电话 S-->
          <xl-select-contacts ref="dialRef"></xl-select-contacts>
          <!-- 拨打电话 N-->
          <!--线索池 转移 S-->
          <xl-pool-transfer ref="transferPoolRef" @cb="refreshList"></xl-pool-transfer>
          <!--分配-->
          <xl-distribution ref="distributionRef" @cb="refreshList"></xl-distribution>
          <!-- 编辑弹窗 -->
          <fh-add-edit ref="addEditRef" @cb="refreshList" />
          <!-- 天科云外呼 S -->
          <xl-out-call-tky ref="tkyRef" />
          <!-- 天科云外呼 E -->
          <!-- 传显科技 - 外呼 S -->
          <xl-out-call-cxkj ref="cxkjRef" />
          <!-- 传显科技 - 外呼 E -->
        </template>
      </div>
    </teleport>
  </div>
</template>

<script setup>
import { reactive, ref, computed, provide, inject, watch, nextTick } from 'vue';
import { Message, Modal } from '@arco-design/web-vue';
import { publicService } from '@/api/';
import { tools } from '@/utils/tools';
import { objEntityMapping, computingStatus } from '@/utils/const';
import { useUserStore, useContactsStore } from '@/store';
import useButtonEvent from '@/hooks/button-event.js';
import { useI18n } from 'vue-i18n';
import ClueConversion from '@/views/leads/components/clue-conversion/index.vue';
import { QfeiIconEditOutlined, QfeiIconMoveOutlined, QfeiIconReturnOrderOutlined, QfeiIconConversionTwoOutlined, QfeiIconShareOutlined, QfeiIconDeleteOutlined, QfeiIconCopyOutlined, QfeiIconRecordAddOutlined, QfeiIconPhoneOutlined, QfeiIconOrderOutlined, QfeiIconRefreshOutlined, QfeiIconSubTaskOutlined } from '@qfei-design/icons-vue';
// console.log('1-开始创建组件-setup');
const data = reactive({
  record: {
    id: null
  },
  outCallDisabled: false,
  viewId: inject('defaultParams')?.viewId,
  poolId: inject('defaultParams')?.poolId
});
const isShowComponents = ref(false);
const { collection, isPoolManager, shareRowData, deleteObj, clueReturn, getTaskId, dialCallPhone, handleDataCalibration } = useButtonEvent();
const oem = ref(JSON.parse(JSON.stringify(objEntityMapping)));
const props = defineProps({
  entityId: {
    type: Number || String,
    default: null || ''
  },
  recordObj: {
    type: Object,
    default: () => {}
  },
  fieldsListAll: {
    type: Object,
    default: () => {}
  },
  viewId: {
    type: Number || String,
    default: null || ''
  },
  tableDataLength: {
    type: Number || String,
    default: null || ''
  },
  computedStatus: {
    type: Number || String
  },
  moreNumber: {
    type: Number,
    default: 8
  },
  morePosition: {
    type: String,
    default: 'top'
  }
});
const record = ref(props.recordObj);
// const recordComputedStatus = computed(() => props.recordObj?.computedInfo?.status);
const isReturnShow = ref(false);
const isDistributionShow = ref(false);
const isAddEditShow = ref(false);
const isCallCxkjShow = ref(false);
const isCallTkyShow = ref(false);
const isClueConversionShow = ref(false);
const isTransferShow = ref(false);
const isPoolTransferShow = ref(false);
const isSelectContractsShow = ref(false);
const entity = ref(props.entityId);
const viewIdRef = ref(props?.viewId || data.viewId);
const btnPermission = computed(() => props.fieldsListAll);
// console.log(1265, record.value, entity.value, btnPermission.value);
const moreNumber = computed(() => props.moreNumber); //操作栏按钮显示数量
const { t } = useI18n();
const emits = defineEmits(['cb', 'clearSelected', 'popupVisibleChangeBtn']);
const getContactList = useContactsStore();
const { userInfo } = useUserStore();
const addEditRef = ref(); // 编辑弹窗
const transferRef = ref(); // 转移线索
const transferPoolRef = ref(null); // 转移线索
// 领储7  天客云tkyRef
const tkyRef = ref();
// 条道12  传显科技cxkjRef
const cxkjRef = ref();
const dialRef = ref(); //拨打电话组件
const distributionRef = ref(); //
/********************回传的按钮******************************* */
const buttonTexts = ref({});
const getBtnPermissionObj = () => {
  buttonTexts.value = {};
  //获取按钮的icon
  buttonTexts.value = tools.getOptTextsByEntity(userInfo?.menus?.entityResources, entity.value);
};
console.log(266, '按钮权限', buttonTexts.value);
/**********************回传的按钮***************************** */
// 复制操作
const copyClue = async (record) => {
  await nt();
  const params = { id: record.id, type: 30, viewId: viewIdRef.value, entity: entity.value, copy: 1 };
  isAddEditShow.value = true;
  addEditRef.value?.open(params);
};
const selectRecord = ref({});

// 数据校准
const saveDataCheck = async (record) => {
  await nt();
  Modal.info({
    titleAlign: 'start',
    width: 400,
    simple: false,
    title: t('数据校准确认'),
    content: t('数据校准将会触发计算字段重新计算，是否确认？'),
    onOk: () => {
      handleCaliBration(record);
    }
  });
};

// 计算字段数据校准
const handleCaliBration = async (record) => {
  try {
    const res = await handleDataCalibration(entity.value, [record.id]);
    if (!res) {
      Message.error(res.error?.msg || t('操作失败'));
      return;
    }
    if (!res.error) {
      Message.success('操作成功');
      refreshList();
    } else {
      Message.error(res.error?.msg || t('操作失败'));
    }
  } catch (error) {
    console.log(error);
  }
};

// 删除操作--统一调用自定义对象的删除
const deleteRow = async (record) => {
  await nt();
  Modal.confirm({
    titleAlign: 'start',
    width: 400,
    simple: false,
    title: t('删除确认'),
    content: t('删除后该数据将不可恢复，是否确认？'),
    onOk: () => {
      doDeleteRow(record);
    }
  });
};
// 删除api
const doDeleteRow = async (record) => {
  try {
    const params = {
      entity: entity.value,
      businessId: record.id
    };
    await deleteObj(params).then((res) => {
      if (res) {
        refreshList({ type: 'refreshRow', id: record.id, setPage: props.tableDataLength == 1 ? true : false });
      }
    });
  } catch (e) {
    console.log(e);
  }
};
// 刷新回调
const refreshList = (tp) => {
  console.log(231, tp, record.value);
  emits('cb', tp, { btnType: ['return', 'transfer'].includes(tp) ? tp : null, id: record.value.id });
};
// 打开弹窗前先加载这一行的DOM
const nt = async () => {
  isShowComponents.value = true;
  await nextTick();
};

const addDynamicRecord = async () => {
  await nt();
  // isSourceDetailStatus 是否隐藏 关联对象名称与 关联对象数据
  const params = { id: '', type: 30, viewId: -1, entity: 16, copy: 0, followObj: { isSourceDetailStatus: true, sourceEntity: entity.value, sourceId: record.value.id } };
  addEditRef.value?.open(params);
};

// 编辑
const toEdit = async (record) => {
  console.log(213, record);
  await nt();
  const params = { id: record.id, type: 40, viewId: viewIdRef.value || -1, entity: entity.value };
  if (entity.value == 10) {
    if (record?.returnStatus != '部分退货' && record?.returnStatus != '全部退货') {
      addEditRef.value?.open(params);
    } else {
      Message.warning(t('该订单关联的有退货信息，暂不支持编辑'));
    }
  } else {
    addEditRef.value?.open(params);
  }
};
//退回
const returnRef = ref();
const returnClue = async (record) => {
  await nt();
  try {
    await clueReturn({ businessIds: [record.id] }).then((res) => {
      if (res) {
        const params = {
          title: t('退回'),
          ids: [record.id]
        };
        isReturnShow.value = true;
        returnRef.value.returnShow(params);
      }
    });
  } catch (e) {
    console.log(e);
  }
};
const bingSyncData = async (record) => {
  console.log(470, record);
  await nt();
  try {
    const params = {
      type: entity.value,
      ids: [record.input_rbKcJb]
    };
    const json = await publicService.refreshData(params);
    if (!json.error) {
      console.log(147, json.result);
      Message.success('数据同步中，同步完成后将自动刷新数据');
      refreshList();
    } else {
      Message.error(json.error?.msg || '数据同步失败，请重试!');
    }
  } catch (e) {
    Message.error(e.message || e.statusText || '数据同步失败，请重试!');
  }
};

// Bing数据同步
const bingUserInviteSync = async (record) => {
  await nt();
  try {
    const params = {
      type: entity.value,
      ids: [record?.id],
      isUserInvite: true,
      isCustomer: true
    };
    const json = await publicService.refreshData(params);
    if (!json.error) {
      Message.success('邀请数据同步中，同步完成后将自动刷新数据');
      refreshList();
    } else {
      Message.error(json.error?.msg || '邀请数据同步失败，请重试!');
    }
  } catch (e) {
    Message.error(e.message || e.statusText || '邀请数据同步失败，请重试!');
  }
};
// ui后台详情跳转
const bingUrl = async (record) => {
  await nt();
  try {
    console.log('record', record);
    const params = {
      type: entity.value,
      ids: [record.id]
    };
    const json = await publicService.getUrl(params);
    if (!json.error) {
      Message.success('成功');
      refreshList();
      setTimeout(() => {
        window.open(json?.result, '_blank');
      }, 1000);
    } else {
      Message.error(json.error?.msg || '失败!');
    }
  } catch (e) {
    Message.error(e.message || e.statusText || '失败!');
  }
};
// 分享
const memberRef = ref();
const toShare = async (record) => {
  await nt();
  if (btnPermissionArr.value.slice(moreNumber.value).includes(`${oem.value[entity.value]}:share`)) {
    memberRef.value.openDialog();
  }
  selectRecord.value = record;
};

// 分享功能
const getVal = async (v) => {
  await nextTick();
  console.log('角色员工人员选择查看:', v);
  // 选择人员后，调添加人员接口，参数都在v中，按需去V中取
  const userIds = v?.userList?.map((u) => u.id);
  // 分享消息卡片接口
  const params = { userIds, id: selectRecord.value?.id, type: entity.value };
  await shareRowData(params);
  emits('clearSelected');
};

// 转化为客户或者转化为客户和商机
const conversionRef = ref();
const msqlTaskId = ref();
// 线索转化为客户或者转化为客户和商机
const conversion = async (record) => {
  await nt();
  data.record.id = record?.id;
  selectRecord.value = record;
  await getMsqlTaskId(record);
  isClueConversionShow.value = true;
  conversionRef.value.open();
};
// 根据主键查询线索
const getMsqlTaskId = async (record) => {
  try {
    const params = {
      id: record.id
    };
    await getTaskId(params).then((res) => {
      if (res) {
        console.log(55555, res);
        msqlTaskId.value = res;
      }
    });
  } catch (e) {
    Message.error(e.message || e.statusText || t('获取数据失败'));
  }
};
// 拨打电话
const dialPhone = async (record) => {
  await nt();
  data.record.id = record.id;
  const params = {
    businessId: data.record.id, //线索id
    type: entity.value, //1-线索 2-客户 3-商机 4-产品
    calling: true
  };
  getContactList.getContactList(params).then((res) => {
    console.log(586, res);
    const rt = res.result;
    if (rt?.length) {
      if (params.calling && rt?.length === 1) {
        data.outCallDisabled = true;
        const rtl = rt[0];
        const callParams = {
          id: params.businessId, //主键id
          type: params.type,
          ...rtl
        };
        dialCallPhone(callParams).then((rp) => {
          const np = { id: params.businessId, type: params.type, linkManId: rtl.id };
          if (rp.type === 2) {
            console.log('拨打信息555');
            // 天科云
            isCallTkyShow.value = true;
            tkyRef.value?.open(np);
          } else if (rp.type === 3) {
            // 传显科技
            isCallCxkjShow.value = true;
            cxkjRef.value?.open(np);
          }
          data.outCallDisabled = false;
        });
      } else if (params.calling && rt?.length >= 2) {
        isSelectContractsShow.value = true;
        dialRef.value.contactsShow();
      }
    }
  });
};
//转移
const leadBatch = async (record) => {
  await nt();
  // type=1单个转移，type=2批量转移
  data.record.id = record.id;
  const params = {
    title: t('转移'),
    ids: [data.record.id],
    changeFlag: entity.value === 2 || entity.value === 3 ? true : false //是否可变更其他负责人
  };
  isTransferShow.value = true;
  transferRef.value.transferShow(params);
};
// 领取线索
const currentCollectionClue = ref(null);
const poolLoading = ref(false);
const collectionClue = async (record) => {
  await nt();
  currentCollectionClue.value = record.id;
  console.log(332, record);
  try {
    const params = {
      businessIds: [record.id],
      poolId: data.poolId
    };
    poolLoading.value = true;
    collection(params).then((res) => {
      poolLoading.value = false;
      if (res) {
        refreshList();
      }
    });
  } catch (e) {
    poolLoading.value = false;
    console.log(e);
  }
};
// 分配
const distribution = async (record) => {
  await nt();
  const result = await isPoolManager({ poolId: data.poolId });
  if (result) {
    const params = {
      businessIds: [record.id],
      poolId: data.poolId,
      title: t('分配')
    };
    console.log('子组件', distributionRef.value);
    isDistributionShow.value = true;
    distributionRef.value.transferShow(params);
  } else {
    Message.error(t('您非线索池管理员，不可分配线索'));
  }
};

//转移
const leadPoolBatch = async (record) => {
  // type=1单个转移，type=2批量转移record.id;
  await nt();
  const params = {
    businessIds: [record.id],
    poolId: data.poolId,
    title: t('转移线索池')
  };
  console.log('子组件', transferRef.value);
  isPoolTransferShow.value = true;
  console.log(571, transferPoolRef.value);
  transferPoolRef.value?.getOptions(params.poolId);
  transferPoolRef.value.transferShow(params);
};
// UI后台详情
const bingUserInviteUrlSync = async (record) => {
  await nt();
  try {
    const params = {
      type: entity.value,
      ids: [record?.id],
      isUserInvite: true,
      isCustomer: false
    };
    const json = await publicService.getUrl(params);
    if (!json.error) {
      Message.success('成功');
      refreshList();
      setTimeout(() => {
        window.open(json?.result, '_blank');
      }, 1000);
    } else {
      Message.error(json.error?.msg || '失败!');
    }
  } catch (e) {
    Message.error(e.message || e.statusText || '失败!');
  }
};
watch(
  () => entity.value,
  (v) => {
    if (v >= 200) {
      oem.value[v] = v;
    }
  },
  {
    deep: true,
    immediate: true
  }
);
watch(
  () => viewIdRef.value,
  () => {
    getBtnPermissionObj();
  },
  {
    deep: true,
    immediate: true
  }
);
provide('msqlTaskId', {
  id: computed(() => msqlTaskId.value)
});
provide('defaultParams', {
  id: computed(() => selectRecord.value?.id),
  entity: computed(() => entity.value)
});
const selectButton = (e) => {
  // 添加动态记录
  if (e === buttonTexts.value?.[`${oem.value[entity.value]}:addDynamicRecord`]) {
    addDynamicRecord();
  }
  console.log(e);
  // 编辑
  if (e === buttonTexts.value?.[`${oem.value[entity.value]}:edit`]) {
    toEdit(record.value);
  }
  // 复制
  if (e === buttonTexts.value?.[`${oem.value[entity.value]}:copy`]) {
    copyClue(record.value);
  }
  // 转移
  if (e === buttonTexts.value?.[`${oem.value[entity.value]}:transfer`]) {
    if (entity.value == 101) {
      leadPoolBatch(record.value);
    } else {
      leadBatch(record.value);
    }
  }
  // 退回
  if (e === buttonTexts.value?.[`${oem.value[entity.value]}:return`]) {
    returnClue(record.value);
  }
  // 转化
  if (e === buttonTexts.value?.[`${oem.value[entity.value]}:transform`]) {
    conversion(record.value);
  }
  // 分享
  if (e === buttonTexts.value?.[`${oem.value[entity.value]}:share`]) {
    toShare(record.value);
  }
  // 删除
  if (e === buttonTexts.value?.[`${oem.value[entity.value]}:delete`]) {
    deleteRow(record.value);
  }
  // 数据校准
  if (e === buttonTexts.value?.[`${oem.value[entity.value]}:dataCheck`]) {
    saveDataCheck(record.value);
  }
  // 复制
  if (e === buttonTexts.value?.[`${oem.value[entity.value]}:copy`]) {
    copyClue(record.value);
  }
  // 拨打
  if (e === buttonTexts.value?.[`${oem.value[entity.value]}:calling`]) {
    dialPhone(record.value);
  }
  // bing数据同步
  if (e === buttonTexts.value?.[`${oem.value[entity.value]}:bingDataSync`]) {
    bingSyncData(record.value);
  }
  // bing租户特殊操作
  if (e === buttonTexts.value?.[`${oem.value[entity.value]}:bingUserInviteSync`]) {
    bingUserInviteSync(record.value);
  }
  // 领取
  if (e === buttonTexts.value?.[`${oem.value[entity.value]}:receive`]) {
    collectionClue(record.value);
  }
  // 分配
  if (e === buttonTexts.value?.[`${oem.value[entity.value]}:allocation`]) {
    distribution(record.value);
  }
  // 销售订单bing链接
  if (e === buttonTexts.value?.[`${oem.value[entity.value]}:bingUrl`]) {
    bingUrl(record.value);
  }
  //
  if (e === buttonTexts.value?.[`${oem.value[entity.value]}:bingUrl`]) {
    bingUserInviteUrlSync(record.value);
  }
};

//处理按钮权限
const handleBtnPermission = () => {
  // 获取当前实体的前缀
  const entityPrefix = `${oem.value[entity.value]}`;

  // 检查用户是否有特定权限
  const hasPermission = (permission) => {
    return userInfo?.roles?.indexOf(`${entityPrefix}:${permission}`) !== -1;
  };
  // console.log('是否有权限333', hasPermission('edit'));

  // 检查记录是否被锁定或状态为1或6
  const isRecordAvailable = () => {
    return !record.value?.lockedOrigin && record.value?.statusOrigin != 1 && record.value?.statusOrigin != 6;
  };
  console.log('updateBtnPermissions-5', btnPermission.value);
  // 处理特殊按钮的权限逻辑
  const specialButtonLogic = (b) => {
    const buttonType = b.split(':')[1];

    // 添加动态记录
    if (buttonType === 'addDynamicRecord') {
      console.log('是否有权限111', hasPermission('addDynamicRecord'), userInfo?.roles?.indexOf(`${oem.value[16]}:add`) !== -1, props.recordObj?.ADD_DYNAMIC_RECORD_PERMISSION == '1', props.recordObj, record.value);
      return hasPermission('addDynamicRecord') && userInfo?.roles?.indexOf(`${oem.value[16]}:add`) !== -1 && props.recordObj?.ADD_DYNAMIC_RECORD_PERMISSION == '1';
    }

    // 编辑
    if (buttonType === 'edit') {
      return (entity.value == 101 || (!record.value?.lockedOrigin && entity.value != 101)) && hasPermission('edit');
    }

    // 转移
    if (buttonType === 'transfer') {
      if (entity.value == 3) {
        return isRecordAvailable() && record.value?.customerId && record.value?.opportunityStatus != '赢单' && hasPermission('transfer');
      }
      if (entity.value == 101) {
        return hasPermission('transfer');
      }
      return isRecordAvailable() && hasPermission('transfer');
    }

    // 退回
    if (buttonType === 'return') {
      return entity.value == 1 && isRecordAvailable() && hasPermission('return');
    }

    // 转化
    if (buttonType === 'transform') {
      return entity.value == 1 && isRecordAvailable() && hasPermission('transform') && !record.value?.customerId && record.value?.clueStatus != '已转化';
    }

    // 其他一般按钮，只需检查权限
    return hasPermission(buttonType);
  };

  // 过滤按钮列表
  return btnPermission.value.filter((b) => {
    // 确保按钮格式正确
    if (!b.startsWith(entityPrefix)) return false;

    return specialButtonLogic(b);
  });
};

// 使用ref而不是computed，这样可以直接修改值
const btnPermissionArr = ref([]);

// 更新按钮权限的函数
const updateBtnPermissions = () => {
  const basePermissions = handleBtnPermission();

  // 如果是计算状态(status=1 || 3 处理中)，则只保留复制按钮
  if (basePermissions.length && computingStatus.includes(Number(props.computedStatus))) {
    btnPermissionArr.value = basePermissions.filter((item) => item === `${oem.value[entity.value]}:copy`) || [];
  } else {
    // console.log('计算状态直接变化222', basePermissions);
    btnPermissionArr.value = basePermissions;
  }
};

const handlePopupVisibleChange = (e) => {
  emits('popupVisibleChangeBtn', e);
};

// 监听整个记录对象的变化（用于轮询更新的情况）
watch(
  () => [props.recordObj, props.computedStatus],
  () => {
    // console.log('计算状态直接变化1111', newRecord, newStatus);
    updateBtnPermissions();
  },
  { immediate: true, deep: true }
);
</script>
<style scoped lang="less">
@import './shortcut-btn.less';
</style>
